export default __webpack_public_path__ + "static/media/partial-app-in-iphone.fa3eaee3.png";